import type { LoginSchema } from '@repo/schemas/auth/login';

import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useMutation } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { AuthService } from './authService';

export function usePostLogin() {
  const loginMutation = useMutation({
    mutationFn: (data: LoginSchema) => AuthService.postLogin(data).then((response) => response.data),
  });

  const errorMessage = useErrorMessage(loginMutation.error, baseErrorMessages);

  return {
    ...loginMutation,
    errorMessage,
  };
}
